import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColorTypes, IconSizeTypes, IconTypes } from '@models/svg-icon.model';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  imports: [CommonModule],
  styleUrl: './svg-icon.component.scss',
  template: `<div
    class="svg-icon {{ extraClass }}"
    [ngClass]="{ 'svg-icon--full': isFull }"
    [style.width.px]="width"
    [style.height.px]="height"
  >
    <svg
      attr.width="{{ width }}"
      attr.height="{{ height }}"
      class="size-{{ size }}"
    >
      <use
        attr.xlink:href="#{{ icon }}"
        class="fill-{{ fill }} stroke-{{ stroke }}"
        attr.fill="{{ fillRgb }}"
      ></use>
    </svg>
  </div> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent {
  @Input() size: IconSizeTypes | undefined;
  @Input() icon: IconTypes | undefined;
  @Input() extraClass: string | undefined;
  @Input() width: number | undefined;
  @Input() height: number | undefined;
  @Input() fill: IconColorTypes | undefined;
  @Input() fillRgb: string | undefined;
  @Input() stroke: IconColorTypes | undefined;

  // height and width are 100% to fill in the parent container
  @Input() isFull?: boolean;
}
